import React from "react";
import projectImage from "../Img/service-img-bg.jpg";

const projects = [
    {
        title: "4-Level Pit Parking – Mumbai",
        image: projectImage,
        description: "Installed at a commercial complex in South Mumbai with a capacity of 32 vehicles.",
    },
    {
        title: "Puzzle Parking – Thane",
        image: projectImage,
        description: "Deployed for a residential tower with limited surface space, enabling 18 car slots.",
    },
    {
        title: "Rotary Parking – Pune",
        image: projectImage,
        description: "Ferris-style vertical rotary parking installed in a narrow urban lane.",
    },
    {
        title: "Tower Parking – Delhi NCR",
        image: projectImage,
        description: "Multi-car vertical tower system built near a metro station for high daily turnover.",
    },
    {
        title: "2-Level Pit Parking – Surat",
        image: projectImage,
        description: "Twin-deck basement parking for a textile firm with dedicated staff access.",
    },
];

const OurProjects = () => {
    return (
        <>
            <div className="about-section">
                <h2 className="lt-service-grid-heading">Our Projects</h2>
                <p>
                    Over the years, LIFTECH ENGINEERING PVT. LTD. has successfully executed a wide array of parking system installations across India, catering to both public and private sector clients. Our projects span residential towers, commercial complexes, hospitals, shopping malls, and municipal infrastructures — all tailored to specific site conditions and customer expectations.
                </p>
                <p>
                    From compact two-level systems in gated societies to sophisticated tower and puzzle parking structures in high-density zones, every project we deliver reflects our engineering excellence and deep industry knowledge. Each solution is custom-built, ensuring optimal capacity utilization, ease of maintenance, and long-term functionality.
                </p>
            </div>
            <section className="lt-service-grid-section">
                {/* Project Cards */}
                <div className="lt-service-grid">
                    {projects.map((project, idx) => (
                        <div className="lt-service-card" key={idx}>
                            <img src={project.image} alt={project.title} className="lt-service-image" />
                            <div className="lt-service-content">
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>
                                <button className="lt-know-more">View Details</button>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default OurProjects;
